export const bank_account = (id) => `/v2/guest/bank-accounts/${id}`;
export const campaigns = (id, type) => `/v2/guest/ngo-campaigns/${type}/${id}`;
export const INIT_PYMENT = `v2/guest/init-payment`;
export const FINALIZE_PAYMENT = `v2/guest/do-payment`;
export const AVAILABLE_METHODS = (id) => `v2/guest/ngo-payments/${id}`;
